import { NavLink } from 'react-router-dom';

/**
 * 📱 شريط تنقّل سفلي للموبايل — يعمل كأنه تطبيق
 *    يظهر فقط على الموبايل (md:hidden)
 *    يستخدم في PublicLayout و AuthLayout
 */
export function MobileBottomNav() {
  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      aria-label="التنقل السفلي"
    >
      <div className="grid grid-cols-4 h-16">
        <Tab to="/" end label="الرئيسية" icon={
          <>
            <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </>
        } />
        <Tab to="/auctions" label="المزادات" icon={
          <>
            <path d="m14 13-7.5 7.5c-.83.83-2.17.83-3 0 0 0 0 0 0 0a2.12 2.12 0 0 1 0-3L11 10" />
            <path d="m16 16 6-6" />
            <path d="m8 8 6-6" />
            <path d="m9 7 8 8" />
            <path d="m21 11-8-8" />
          </>
        } />
        <Tab to="/map" label="الخريطة" icon={
          <>
            <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" />
            <line x1="8" y1="2" x2="8" y2="18" />
            <line x1="16" y1="6" x2="16" y2="22" />
          </>
        } />
        <Tab to="/dashboard" label="حسابي" icon={
          <>
            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </>
        } />
      </div>
    </nav>
  );
}

function Tab({ to, end, label, icon }: { to: string; end?: boolean; label: string; icon: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `flex flex-col items-center justify-center gap-0.5 transition ${
          isActive ? 'text-gold' : 'text-navy-dark/60 active:text-navy-dark'
        }`
      }
    >
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        {icon}
      </svg>
      <span className="text-[10px] font-bold">{label}</span>
    </NavLink>
  );
}
